<template>
  <div class="flex items-center flex-col custom-style-page el-tip-tap-font">
    <v-container class="px-10 pb-10">
      <v-row class="not-print-content">
        <v-col>
          <v-card class="px-8 py-4">
            <v-form ref="form" lazy-validation>
              <v-row justify="center">
                <v-col cols="12" lg="10" class="pb-5">
                  <WarrantyTitleEditor
                    :content="titleContentEditor"
                    @update:title="updateTitle"
                  />
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col cols="12" lg="10">
                  <v-text-field
                    v-model="productName"
                    outlined
                    label="Tên sản phẩm*"
                    hide-details
                    class="text-field-small"
                  />
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col cols="12" sm="6" lg="5">
                  <v-text-field
                    v-model="purchaseDate"
                    outlined
                    label="Ngày mua"
                    hide-details
                    class="text-field-small"
                  />
                </v-col>
                <v-col cols="12" sm="6" lg="5">
                  <v-text-field
                    v-model="productStatusName"
                    outlined
                    label="Tình trạng"
                    hide-details
                    class="text-field-small"
                  />
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col cols="12" sm="6" lg="5">
                  <v-text-field
                    v-model="msp"
                    outlined
                    label="MSP (iMei)"
                    hide-details
                    class="text-field-small"
                  />
                </v-col>
                <v-col cols="12" sm="6" lg="5">
                  <v-text-field
                    v-model="productGuarranName"
                    outlined
                    label="Bảo hành"
                    hide-details
                    class="text-field-small"
                  />
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col cols="12" sm="6" lg="5">
                  <v-text-field
                    v-model="price"
                    outlined
                    label="Giá sản phẩm"
                    hide-details
                    class="text-field-small"
                  />
                </v-col>
                <v-col cols="12" sm="6" lg="5">
                  <v-text-field
                    v-model="paymentMethodName"
                    outlined
                    label="Hình thức mua"
                    hide-details
                    class="text-field-small"
                  />
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col cols="12" sm="6" lg="5">
                  <v-text-field
                    v-model="customerName"
                    outlined
                    label="Tên khách hàng"
                    hide-details
                    class="text-field-small"
                  />
                </v-col>
                <v-col cols="12" sm="6" lg="5">
                  <v-text-field
                    v-model="phone"
                    outlined
                    label="Số điện thoại"
                    hide-details
                    class="text-field-small"
                  />
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col cols="12" sm="6" lg="5">
                  <v-text-field
                    v-model="icloud"
                    outlined
                    label="Tài khoản icloud"
                    hide-details
                    class="text-field-small"
                  />
                </v-col>
                <v-col cols="12" sm="6" lg="5">
                  <v-text-field
                    v-model="password"
                    outlined
                    label="Mật khẩu"
                    hide-details
                    class="text-field-small"
                  />
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col cols="12" lg="10" class="pb-5">
                  <WarrantyAdditionEditor
                    :content="additionContentEditor"
                    @update:addition="updateAddition"
                  />
                </v-col>
              </v-row>
            </v-form>
          </v-card>
        </v-col>
      </v-row>
      <div
        v-html="contentPrinted"
        class="print-content el-tiptap-editor__content custom-border-tiptap"
      />
    </v-container>
  </div>
</template>

<script>
import WarrantyTitleEditor from "./WarrantyTitleEditor.vue";
import WarrantyAdditionEditor from "./WarrantyAdditionEditor.vue";
import { WARRANTY_TITLE_TEMPLATE } from "~/utils/warrantyTitleTemplate.js";
import { WARRANTY_ADDITION_TEMPLATE } from "~/utils/warrantyAdditionTemplate.js";

export default {
  name: "PhieuBaoHanhForm",

  components: {
    WarrantyTitleEditor,
    WarrantyAdditionEditor,
  },

  data() {
    return {
      titleContentEditor: null,
      additionContentEditor: null,
      isLoading: false,
      productName: null,
      purchaseDate: null,
      productStatusName: null,
      msp: null,
      productGuarranName: null,
      price: null,
      paymentMethodName: null,
      customerName: null,
      phone: null,
      icloud: null,
      password: null,
    };
  },

  computed: {
    contentPrinted() {
      return (
        this.titleContentEditor +
        `
        <div class="flex items-center flex-col mt-2 custom-style-page">
          <ul class="w-9/12 pl-0 leading-5">
            <li>
              <p><strong>Tên sản phẩm: </strong> ${this.productName || ""}</p>
            </li>
            <li>
              <p class="flex justify-between">
                <span class="flex w-2/3">
                  <strong>Ngày mua: </strong>
                  <span class="flex-grow text-center">${this.purchaseDate || ""}</span>
                </span>
                <span class="flex w-1/3">
                  <strong class="mr-2">Tình trạng: </strong>
                    ${this.productStatusName || ""}
                  </span>
              </p>
            </li>
            <li>
              <p class="flex justify-between">
                <span class="flex w-2/3">
                  <strong>MSP (iMei): </strong>
                  <span class="flex-grow text-center">${this.msp || ""}</span>
                </span>
                <span class="flex w-1/3"
                  ><strong class="mr-2">Bảo hành: </strong>${
                    this.productGuarranName || ""
                  }</span
                >
              </p>
            </li>
            <li>
              <p class="flex justify-between">
                <span class="flex w-2/3">
                  <strong>Giá sản phẩm: </strong>
                  <span class="flex-grow text-center">${this.price || ""}</span>
                </span>
                <span class="flex w-1/3"
                  ><strong class="mr-2">Hình thức mua: </strong>${
                    this.paymentMethodName || ""
                  }</span
                >
              </p>
            </li>
            <li>
              <p class="flex justify-between">
                <span class="flex w-2/3">
                  <strong>Tên khách hàng: </strong>
                  <span class="flex-grow text-center">${this.customerName || ""}</span>
                </span>
                <span class="flex w-1/3"><strong class="mr-2">SĐT: </strong>${
                  this.phone || ""
                }</span>
              </p>
            </li>
            <li>
              <p><strong class="mr-2">Tài khoản iCloud: </strong>${this.icloud || ""}</p>
            </li>
            <li>
              <p><strong class="mr-2">Mật khẩu: </strong>${this.password || ""}</p>
            </li>
          </ul>
        </div>
      ` +
        this.additionContentEditor
      );
    },
  },

  async created() {
    try {
      this.isLoading = true;
      const { phonbuyid } = this.$route.params;
      const data = await this.$services.phonebuyService.getPhoneBuy(phonbuyid);

      if (data) {
        this.productName = data?.productName;
        this.msp = data?.productIMEI;
        this.purchaseDate = data?.productDateBuy;
        this.productStatusName = data?.productStatusName;
        this.productGuarranName = data?.productGuarranName;
        this.price = data?.productPriceFormat;
        this.paymentMethodName = data?.paymentMethodName;
        this.customerName = data?.customerName;
        this.phone = data?.customerPhone;
        this.icloud = data?.customerCloud;
        this.password = data?.customerCloudPassword;
      }

      this.titleContentEditor = localStorage.getItem("le-phong-mobile-title-editor");
      if (!this.titleContentEditor) {
        this.titleContentEditor = WARRANTY_TITLE_TEMPLATE;
      }
      this.additionContentEditor = localStorage.getItem(
        "le-phong-mobile-addition-editor"
      );
      if (!this.additionContentEditor) {
        this.additionContentEditor = WARRANTY_ADDITION_TEMPLATE;
      }
    } catch (err) {
      console.log(err);
    } finally {
      this.isLoading = false;
      this.activate();
    }
  },

  methods: {
    updateTitle(value) {
      this.titleContentEditor = value;
      localStorage.setItem("le-phong-mobile-title-editor", this.titleContentEditor);
    },
    updateAddition(value) {
      this.additionContentEditor = value;
      localStorage.setItem("le-phong-mobile-addition-editor", this.additionContentEditor);
    },
    activate() {
      setTimeout(() => window.print(), 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-style-page {
  font-size: 14px !important;
  font-family: "Times New Roman", Times, serif;
  padding: 0 32px;
}

.print-content {
  display: none;
}

@media print {
  .not-print-content {
    display: none;
  }

  .print-content {
    display: block;
  }
  .custom-style-page {
    padding: 0;
  }
}
</style>
